import _ from 'lodash';
import { useQuery } from 'react-query';
import { AdGroupDto, DataScopeDto, RoleDto } from '../../../../codegen/Swagger';
import { getApi } from '../../../../config/SwaggerApi';
import { configQueryReactSimpleRequestSecurity } from '../../config';
import { sortItemsByName } from '../../services/AdGroupsService';

const fetchAdGroups = (model: RoleDto) =>
    getApi()
        .security.securityGetAdGroupsDataScopesGet({
            RoleId: model.id,
        })
        .then((response) => response.data);

const useAdGroupsDataScopes = (model: RoleDto, allAdGroups: AdGroupDto[] | undefined) => {
    const adGroupsQuery = useQuery<DataScopeDto[], Error>(['adgroups-', model?.id], () => fetchAdGroups(model), {
        ...configQueryReactSimpleRequestSecurity,
        enabled: model != null,
    });
    const transformIntoArrayOfObjects = (items?: string[] | null) => {
        const data = items?.map((item) => {
            const found = allAdGroups?.find((group) => group.id == item);
            return found;
        });
        return _.compact(data);
    };

    const newData = adGroupsQuery.data?.map((item) => {
        const groupdIdsTransformed = sortItemsByName(transformIntoArrayOfObjects(item.groupIds));
        return { ...item, groupIds: groupdIdsTransformed };
    });

    return { ...adGroupsQuery, data: newData };
};

export default useAdGroupsDataScopes;
